import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { EquipmentCardsLayout } from "@/components/rdo/EquipmentCardsLayout";
import { DialogAddEquipment } from "@/components/rdo/DialogAddEquipment";
import { EditEquipmentModal } from "@/components/rdo/EditEquipmentModal";
import { Truck, Plus } from "lucide-react";

type LegacyEquipmentsSectionProps = {
  value: any;
  onChange: (v: any) => void;
  mode: "edit" | "view";
  // Legacy props for compatibility
  showEquipmentModal?: boolean;
  setShowEquipmentModal?: (show: boolean) => void;
  showEditEquipmentModal?: boolean;
  setShowEditEquipmentModal?: (show: boolean) => void;
  editingEquipment?: any;
  setEditingEquipment?: (equipment: any) => void;
  handleAddEquipment?: (equipment: any) => void;
  handleEditEquipment?: (index: number, equipment: any) => void;
  handleDeleteEquipment?: (index: number) => void;
  isEditing?: boolean;
  isSectionEnabled?: (section: string) => boolean;
};

export function LegacyEquipmentsSection({
  value,
  onChange,
  mode,
  showEquipmentModal = false,
  setShowEquipmentModal = () => {},
  showEditEquipmentModal = false,
  setShowEditEquipmentModal = () => {},
  editingEquipment = null,
  setEditingEquipment = () => {},
  handleAddEquipment = () => {},
  handleEditEquipment = () => {},
  handleDeleteEquipment = () => {},
  isEditing = false,
  isSectionEnabled = () => true,
}: LegacyEquipmentsSectionProps) {
  if (!isSectionEnabled('equipamentos')) {
    return null;
  }

  return (
    <>
      <Card data-section="equipment">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg flex items-center gap-2">
            <Truck className="w-5 h-5" />
            Equipamentos ({(value || []).length})
            {isEditing && mode !== "view" && (
              <Button 
                onClick={() => setShowEquipmentModal(true)} 
                size="sm" 
                className="ml-2"
              >
                <Plus className="w-4 h-4 mr-1" />
                Adicionar
              </Button>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <EquipmentCardsLayout 
            equipment={value?.map((eq: any) => ({
              tipo: eq.type || '',
              identificacao: eq.identification || '',
              condicao: eq.condition || '',
              operador: eq.operator || '',
              tempoOcioso: eq.idleTime?.toString() || '',
              status: eq.ownershipType === 'locado' ? 'locado' : 'proprio',
              quantity: eq.quantity || 1
            })) || []} 
            onEdit={(index) => {
              const equipment = value[index];
              setEditingEquipment({ ...equipment, index });
              setShowEditEquipmentModal(true);
            }}
            onDelete={handleDeleteEquipment}
          />
        </CardContent>
      </Card>

      {/* Legacy Dialogs */}
      <DialogAddEquipment 
        open={showEquipmentModal}
        onOpenChange={setShowEquipmentModal}
        onAdd={(equipment) => {
          handleAddEquipment(equipment);
          setShowEquipmentModal(false);
        }}
      />

      {editingEquipment && (
        <EditEquipmentModal
          open={showEditEquipmentModal}
          onOpenChange={setShowEditEquipmentModal}
          equipment={editingEquipment}
          onSave={(updatedEquipment) => {
            handleEditEquipment(editingEquipment.index, updatedEquipment);
            setShowEditEquipmentModal(false);
            setEditingEquipment(null);
          }}
          onDelete={() => {
            handleDeleteEquipment(editingEquipment.index);
            setShowEditEquipmentModal(false);
            setEditingEquipment(null);
          }}
        />
      )}
    </>
  );
}